/* jshint esnext: true */
import AbstractModule from './AbstractModule';

// import { resizeApi } from '../utils/resize'

export default class extends AbstractModule {
    constructor (options) {
        super(options);

        this.$slider = this.$el.find('.js-slider');

        setTimeout(() => {
            this.$slider.slick({
                arrows: false,
                cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
                dots: true,
                dotsClass: 'c-stats_nav',
                infinite: false,
                speed: 600
            });
        }, 1000);
    }

    destroy() {
        this.$slider.slick('unslick');
        this.$el.off('.StatBlock');
    }
}
